/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  roles.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/3/11 11:33
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */
const rolesRouter = [
    {
        path: '/roles',
        name: 'Roles',
        component: () =>
            import(/* webpackChunkName: "roles" */ '@/views/roleRules/index.vue'),
        meta: {
            title: '角色列表',
            keepAlive: true,
            deepth: 1,
            permission: true
        },
    },
    {
        path: '/roles/roleSetting',
        name: 'RoleSetting',
        component: () =>
            import(/* webpackChunkName: "roles" */ '@/views/roleRules/RoleSetting.vue'),
        meta: {
            title: '权限列表',
            keepAlive: true,
            deepth: 2,
            permission: true
        }
    },
]

export default rolesRouter
